export const Months = [
  { name: "Januari", value: "Jan" },
  { name: "Febuari", value: "Feb" },
  { name: "Maret", value: "Mar" },
  { name: "April", value: "Apr" },
  { name: "Mei", value: "May" },
  { name: "Juni", value: "Jun" },
  { name: "Juli", value: "Jul" },
  { name: "Agustus", value: "Aug" },
  { name: "September", value: "Sep" },
  { name: "Oktober", value: "Oct" },
  { name: "November", value: "Nov" },
  { name: "Desember", value: "Dec" },
];

export const bulan = [
  { name: "Januari", value: 1 },
  { name: "Februari", value: 2 },
  { name: "Maret", value: 3 },
  { name: "April", value: 4 },
  { name: "Mei", value: 5 },
  { name: "Juni", value: 6 },
  { name: "Juli", value: 7 },
  { name: "Agustus", value: 8 },
  { name: "September", value: 9 },
  { name: "Oktober", value: 10 },
  { name: "November", value: 11 },
  { name: "Desember", value: 12 },
];
export const tahun = ["2025", "2026", "2027"];

export const RoleConstant = [
  "finance_admin",
  "finance_user",
  "hrd_admin",
  "hrd_user",
  "mold_admin",
  "mold_user",
  "mesin_admin",
  "mesin_user",
  "p3_user",
  "ppic_admin",
  "ppic_user",
  "produksi_user",
  "produksi_leader",
  "produksi_admin",
  "pr_admin",
  "pr_user",
  "qc_admin",
  "qc_user",
  "security",
  "sp_admin",
  "sp_user",
  "warehouse_admin",
  "warehouse_user",
  "warehouse_mixing",
  "warehouse_crusher",
  "warehouse_gbj_admin",
  "warehouse_gbj_user",
  "uc_admin",
];

export const BagianConstant = [
  { name: "ADM", value: "ADM" },
  { name: "DOKUMEN KONTROL", value: "DOKUMEN KONTROL" },
  { name: "FINISHING", value: "FINISHING" },
  { name: "FINANCE", value: "FINANCE" },
  { name: "GUDANG & EKSPEDISI", value: "GUDANG & EKSPEDISI" },
  { name: "HRD", value: "HRD" },
  { name: "K3", value: "K3" },
  { name: "KEBERSIHAN", value: "KEBERSIHAN" },
  { name: "M Mesin", value: "M Mesin" },
  { name: "M Mold", value: "M Mold" },
  { name: "MR", value: "MR" },
  { name: "PRINTING", value: "PRINTING" },
  { name: "PPIC", value: "PPIC" },
  { name: "PRODUKSI", value: "PRODUKSI" },
  { name: "PURCHASING", value: "PURCHASING" },
  { name: "QC", value: "QC" },
  { name: "SECURITY", value: "Security" },
  { name: "TEKNISI", value: "TEKNISI" },
];

export const jenisKaryawan = [
  { name: "Kontrak", value: "Contract" },
  { name: "Permanen", value: "Permanent" },
];

export const constantYear = [
  { name: "2021", value: "2021" },
  { name: "2022", value: "2022" },
  { name: "2023", value: "2023" },
  { name: "2024", value: "2024" },
  { name: "2025", value: "2025" },
  { name: "2026", value: "2026" },
  { name: "2027", value: "2027" },
];

export const kepalaShiftTimOne = [
  { name: "ACHMAD", value: "ACHMAD" },
  { name: "SARIPUDIN", value: "SARIPUDIN" },
  { name: "SUPRIADI", value: "SUPRIADI" },
  { name: "DIDIN", value: "DIDIN" },
  { name: "MEI", value: "MEI" },
  { name: "NURDIANSYAH", value: "NURDIANSYAH" },
  { name: "MUJI", value: "MUJI" },
  { name: "HARIYADI", value: "HARIYADI" },
  { name: "WAWAN", value: "WAWAN" },
  { name: "ANTHONI", value: "ANTHONI" },
  { name: "DESY", value: "DESY" },
  { name: "MAYA", value: "MAYA" },
  { name: "KHANIFUDIN", value: "KHANIFUDIN" },
];

export const kepalaShiftTimTwo = [
  { name: "MAULANA", value: "MAULANA" },
  { name: "FINDRI", value: "FINDRI" },
  { name: "IMAM PRACOYO", value: "IMAM PRACOYO" },
  { name: "CHAIRUL", value: "CHAIRUL" },
  { name: "IQBAL", value: "IQBAL" },
  { name: "SUHENDAR", value: "SUHENDAR" },
  { name: "BUDI", value: "BUDI" },
  { name: "NAMIN", value: "NAMIN" },
  { name: "AZIZ", value: "AZIZ" },
  { name: "INDAH", value: "INDAH" },
];

export const clockJam = [
  { label: "00", value: "00" },
  { label: "01", value: "01" },
  { label: "02", value: "02" },
  { label: "03", value: "03" },
  { label: "04", value: "04" },
  { label: "05", value: "05" },
  { label: "06", value: "06" },
  { label: "07", value: "07" },
  { label: "08", value: "08" },
  { label: "09", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "14", value: "14" },
  { label: "15", value: "15" },
  { label: "16", value: "16" },
  { label: "18", value: "18" },
  { label: "19", value: "19" },
  { label: "20", value: "20" },
  { label: "21", value: "21" },
  { label: "22", value: "22" },
  { label: "23", value: "23" },
];

export const mock = [
  {
    itemId: "1",
    itemCheck: "Tekanan gas (jika ada)",
    standar: "Jarum pressure gauge pada posisi warma hijau",
    month: [],
  },
  {
    itemId: "2",
    itemCheck: "Kondisi Tabung",
    standar: "Tidak Karat",
    month: [],
  },
  {
    itemId: "3",
    itemCheck: "Kondisi segel",
    standar: "Tidak rusak",
    month: [],
  },
  {
    itemId: "4",
    itemCheck: "Kondisi selang, dan ujung semprot",
    standar: "Tidak retak, tidak patah, tidak pecah, dan masih lentur",
    month: [],
  },
  {
    itemId: "5",
    itemCheck: "Kondisi powder / bubuk",
    standar: "Tidak menggumpal (dikocok 5-6 kali)",
    month: [],
  },
  {
    itemId: "6",
    itemCheck: "Pin pengaman",
    standar: "Terpasang dengan baik",
    month: [],
  },
  {
    itemId: "7",
    itemCheck: "Posisi tanda APAR",
    standar: "Mudah terlihat / tidak terhalang",
    month: [],
  },
  {
    itemId: "8",
    itemCheck: "Posisi APAR",
    standar: "Mudah terlihat / tidak terhalang",
    month: [],
  },
  {
    itemId: "9",
    itemCheck: "Tanggal isi ulang",
    standar: "Lihat label APAR",
    month: [],
  },
  {
    itemId: "10",
    itemCheck: "Masa Kadaluarsa",
    standar: "Tidak kadaluarsa (lihat label masa kadaluarsa)",
    month: [],
  },
  {
    itemId: "11",
    itemCheck: "Kebersihan",
    standar: "Tidak berdebu (lap dengan kain)",
    month: [],
  },
  {
    itemId: "12",
    itemCheck: "Panduan penggunaan APAR",
    standar: "Terpasang dengan benar dan tidak rusak",
    month: [],
  },
  {
    itemId: "13",
    itemCheck: "Berat total APAR",
    standar: "",
    month: [],
  },
  {
    itemId: "14",
    itemCheck: "Petugas",
    standar: "",
    month: [],
  },
];

export const incomingApar = [
  {
    itemId: "1",
    itemCheck: "Tekanan gas",
    standar: "Baik",
  },
  {
    itemId: "2",
    itemCheck: "Bocor",
    standar: "Tidak",
  },
  {
    itemId: "3",
    itemCheck: "Kondisi tabung",
    standar: "Baik",
  },
  {
    itemId: "4",
    itemCheck: "Kondisi segel",
    standar: "Baik",
  },
  {
    itemId: "5",
    itemCheck: "Kondisi tangkai semprot",
    standar: "Baik",
  },
  {
    itemId: "6",
    itemCheck: "Kondisi selang semprot",
    standar: "Baik",
  },
  {
    itemId: "7",
    itemCheck: "Kondisi ujung semprot",
    standar: "Baik",
  },
  {
    itemId: "8",
    itemCheck: "Berat tabung APAR",
    standar: "",
  },
  {
    itemId: "9",
    itemCheck: "Berat isi APAR",
    standar: "",
  },
];

export const apar = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
];

export const posisiConstant = [
  "CHECKER INJEKSI",
  "CHECKER OUTGOING",
  "CHECKER PRINTING",
  "CHECKER SP",
  "DRIVER",
  "KEPALA BAGIAN",
  "KEPALA SHIFT",
  "KERNET",
  "OPERATOR INJEKSI",
  "OPERATOR PRINTING",
  "OPERATOR SP",
  "PELAKSANA",
  "PELAKSANA CRUSHER",
  "PELAKSANA GUDANG",
  "PELAKSANA INJEKSI",
  "PELAKSANA KEAMANAN",
  "PELAKSANA MESIN",
  "PELAKSANA MIXING",
  "PELAKSANA MOLD",
  "PELAKSANA PPP",
  "PELAKSANA KEBERSIHAN",
  "PELAKSANA TIMAH",
  "STAFF",
  "TEKNISI INJEKSI",
  "TEKNISI PRINTING",
  "TEKNISI SP",
];
